import { render, staticRenderFns } from "./AdminSuprazones.vue?vue&type=template&id=cba54d6a&"
import script from "./AdminSuprazones.vue?vue&type=script&lang=js&"
export * from "./AdminSuprazones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports